import {Component, ElementRef, HostBinding, inject, Renderer2, ViewEncapsulation} from '@angular/core';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {delay, Observable, of, pairwise} from 'rxjs';
import {DialogHiddenState} from '~shared/types/dialog.types';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {skip, startWith, switchMap, tap} from 'rxjs/operators';

@Component({
    standalone: true,
    selector: 'app-backdrop',
    encapsulation: ViewEncapsulation.None,
    template: ``,
})
export class BackdropComponent {
    private readonly renderer = inject(Renderer2);
    private readonly elementRef = inject(ElementRef);
    private readonly dialogService = inject(DialogService);

    @HostBinding('attr.class')
    public readonly hostAttrClass = 'offcanvas-backdrop fade';
    @HostBinding('attr.style')
    public readonly hostAttrStyle = 'display: none';

    private hidden: boolean = true;

    constructor() {
        this.dialogService.isModalListEmpty$
            .pipe(
                tap($ => this.hidden = $),
                skip(1),
                switchMap(($: boolean): Observable<DialogHiddenState> => {
                    return of<DialogHiddenState>({
                        transition: false,
                        hidden: $
                    }).pipe(
                        delay(300),
                        startWith<DialogHiddenState>({
                            transition: true,
                            hidden: $
                        }),
                    );
                }),
                startWith<DialogHiddenState>({
                    transition: false,
                    hidden: this.hidden
                }),
                pairwise(),
                takeUntilDestroyed()
            )
            .subscribe(([$old, $new]) => {
                if ($old.hidden !== $new.hidden) {
                    // Hidden state has changed, required actions should be performed.
                    if ($new.hidden) {
                        this.renderer.removeClass(this.elementRef.nativeElement, DialogService.CLASS_SHOW);
                        if ($new.transition === false) {
                            this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
                        }
                    } else {
                        setTimeout(() => {
                            if ($old.transition === false) {
                                this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
                            }
                            setTimeout(() => {
                                this.renderer.addClass(this.elementRef.nativeElement, 'show');
                            }, 50);
                        });

                    }
                } else if ($old.transition !== $new.transition) {
                    // Transition status has changed, required actions should be applied.
                    if ($new.hidden) {
                        // Finished hiding.
                        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
                    } else {
                        // Finished showing.
                    }
                }
            });
    }
}
